
import {UserModel} from './user.model';
import {BaseIdModel} from "../base-id.model";

export class UserTokenModel extends BaseIdModel {
  Token: string;
  User: UserModel;
  CurrentUserId: string;
}
